module.exports = __webpack_public_path__ + "media/src/images/joining-ff178dbcd75d5cd5bdf7e6b2c19e5e48.png";